export default "__VITE_ASSET__D7q79MzN__"